import { render, staticRenderFns } from "./capacityDetail.vue?vue&type=template&id=28698fa0&scoped=true"
import script from "./capacityDetail.vue?vue&type=script&lang=js"
export * from "./capacityDetail.vue?vue&type=script&lang=js"
import style0 from "./capacityDetail.vue?vue&type=style&index=0&id=28698fa0&lang=scss&scoped=true"
import style1 from "./capacityDetail.vue?vue&type=style&index=1&id=28698fa0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28698fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28698fa0')) {
      api.createRecord('28698fa0', component.options)
    } else {
      api.reload('28698fa0', component.options)
    }
    module.hot.accept("./capacityDetail.vue?vue&type=template&id=28698fa0&scoped=true", function () {
      api.rerender('28698fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/capacity/capacityDetail.vue"
export default component.exports